import {useNavigate, useParams} from "react-router-dom";
import HeaderCard from "../../components/tosan/HeaderCard";
import ContentWrapper from "../../components/tosan/ContentWrapper";
import TextField from "../../components/tosan/inputs/TextField";
import BottomButtonWrapper from "../../components/BottomButtonWrapper";
import Button from "../../components/newComponents/button/Button";
import {Formik} from "formik";
import * as Yup from 'yup';
import {handleInputJustUseNumber} from "../../tools/helpers";
import {useContext, useState} from "react";
import genUuid from "../../tools/api/tosan/genUuid";
import DataContext from "../../tools/contexts/tosan/DataContext";
import {Reoverlay} from "reoverlay";
import LoadingModal from "../../components/tosan/modals/LoadingModal";
import ErrorModal from "../../components/tosan/modals/ErrorModal";
import addBill from "../../tools/api/tosan/addBill";
import billTypes from "../../tools/defaults/tosan/billTypes";
import reoverlay from "reoverlay/src/Reoverlay";
import SuccessModal from "../../components/tosan/modals/SuccessModal";
import useAxiosCancel from "../../tools/hoc/useAxiosCancel";

const Services = {
    "tel": {
        name: " قبض تلفن",
        parameter:{
            label:'شماره تلفن',
            placeholder:'شماره تلفن را وارد کنید.'
        }

    },
    "mobile": {
        name: " قبض تلفن همراه",
        parameter:{
            label:'شماره موبایل',
            placeholder:'شماره موبایل را وارد کنید.'
        }

    },
    "water": {
        name: " قبض آب",
        parameter:{
            label:'شناسه قبض',
            placeholder:'شناسه قبض را وارد کنید.'
        }

    },
    "electricity": {
        name: " قبض برق",
        parameter:{
            label:'شناسه قبض',
            placeholder:'شناسه قبض را وارد کنید.'
        }
    },
    "gas": {
        name: " قبض گاز",
        parameter:{
            label:'شناسه قبض',
            placeholder:'شناسه قبض را وارد کنید.'
        }
    }
}
const AddNewBill = () => {
    const params = useParams();
    const {serviceType} = params;
    const navigate = useNavigate();
    const getCancelToken=useAxiosCancel();
    const dataContext=useContext(DataContext);
    const generateParameterValidation=()=>{
        switch (serviceType){
            case "mobile":{
                return Yup.string()
                    .matches(/^(09|۰۹)[0-9۰-۹]{9}$/, 'شماره موبایل نامعتبر می‌باشد.')
                    .required('شماره موبایل الزامیست.');
            }
            case "tel":{
                return   Yup.string()
                    .matches(/^0[0-8۰-۸][0-9۰-۹]{9}$/, 'شماره تلفن نامعتبر می‌باشد.')
                    .required('شماره تلفن الزامیست.');

            }
            default : {
                return Yup.string()
                    .matches(/^[0-9۰-۹]{6,13}$/, 'شماره قبض نامعتبر می‌باشد.')
                    .required('شماره قبض الزامیست.');
            }
        }
    }
    const Validation = Yup.object().shape({
        label: Yup.string().min(2, 'نام مستعار باید حداقل 2 کاراکتر داشته باشد.').max(20, 'نام مستعار حداکثر 20 کاراکتر دارد.'),
        parameter:(generateParameterValidation())

    });

    const handleBillInquiry = async (values) => {
        const cancelToken=getCancelToken();
        Reoverlay.showModal(LoadingModal,{text:'لطفا منتظر بمانید.'});
        const response = await genUuid(dataContext.token,{request_type:'BillInquiry',callback_url:"https://venesh.ir"},cancelToken);

        if(response.isOk){

            if(response.data.uuid && response.data.request_type){
            
                const data={
                    Type:billTypes[serviceType].billType,
                    uuid:response.data.uuid ,
                    Parameter:values.parameter,
                    alias:values.label,
                    Info:1,
                }
                const cancelToken=getCancelToken();
                const inquiryResponse=await addBill(dataContext.token,data,cancelToken);
                Reoverlay.hideModal()
                if(inquiryResponse.isOk){
                    const params={
                        type:billTypes[serviceType].billType,
                        parameter:values.parameter,
                        label:values.label,
                        serviceType:serviceType,
                    }
                    const queryString = new URLSearchParams(params).toString();
                    navigate('/tosan/bill?'+queryString,{
                        state:{
                            data:inquiryResponse.data,
                        }
                    })
                }else {

                    Reoverlay.showModal(ErrorModal,{
                        title:'خطا',
                        message:inquiryResponse.message,
                        cancelButtonTheme:inquiryResponse.status===106 ? "primary":"danger",
                        cancelButtonText:inquiryResponse.status===106 ? "بازگشت" :"بستن",
                        onCancel:()=>{
                            if(inquiryResponse.status===106){
                                navigate(-1)
                            }
                            Reoverlay.hideModal()
                        }
                    })
                }

            }

        }else {

            Reoverlay.hideModal();
            if(!response?.canceled){
                Reoverlay.showModal(ErrorModal,{
                    title:'خطا',
                    message:response.message,
                    cancelButtonTheme:"danger",
                    onCancel:()=>{
                        Reoverlay.hideModal()
                    }
                })
            }

        }


        console.log(values)
    }
    const handleBack = () => {
        navigate(-1)
    }
    return <div>
        <HeaderCard hasBack={false} onBack={handleBack}
                    className={`flex justify-center ${serviceType}-header-card flex-col items-center  ${serviceType}`}>
            <h1 className="title">{Services[serviceType].name}</h1>
        </HeaderCard>
        <ContentWrapper className={'bg-white'}>
            <div className="py-5 border-b"><p className="text-center font-bold text-sm">افزودن قبض جدید</p></div>
            <Formik
                initialValues={{parameter: '', label: ''}}
                onSubmit={handleBillInquiry}
                validationSchema={Validation}
            >
                {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,

                  }) => {

                    return <form className='w-full mt-4 ' onSubmit={handleSubmit}>
                        <TextField label={Services[serviceType].parameter.label} type="text"
                                   name="parameter"
                                   placeholder={Services[serviceType].parameter.placeholder}
                                   onChange={handleChange}
                                   onBlur={handleBlur}
                                   onKeyPress={handleInputJustUseNumber}
                                   value={values.email}/>
                        {errors.parameter && touched.parameter && <p className="text-xs mt-1 text-red-400">{errors.parameter}</p>}
                        <TextField className="mt-3" label='نام مستعار' type="text"
                                   name="label"
                                   onChange={handleChange}
                                   placeholder="نام مستعار را وارد کنید."
                                   onBlur={handleBlur}
                                   value={values.label}/>
                        {errors.label && touched.label && errors.label && <p className="text-xs mt-1 text-red-400">{errors.label}</p>}
                        <BottomButtonWrapper grid={2}>
                            <Button onClick={handleBack}  type="button" rounded="rounded" className={'w-full'} theme="link">بازگشت</Button>
                            <Button   type="submit" rounded="rounded" className={'w-full'} theme="primary">استعلام</Button>

                        </BottomButtonWrapper>
                    </form>
                    }
                }
            </Formik>

        </ContentWrapper>

    </div>
}
export default AddNewBill;